import React from 'react';
import { useTranslation } from 'react-i18next';
import { Download, Smartphone } from 'lucide-react';
import Button from './Button.js';
import { openPlayStore } from '../../utils/nativeApp.js';

const UpdateRequired = ({
  currentVersionCode,
  minimumVersionCode,
  playStoreUrl,
  message,
}) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-gradient-to-br from-purple-50 via-white to-indigo-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-purple-100 bg-white p-8 shadow-xl text-center">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-purple-100 text-purple-700">
          <Smartphone className="h-8 w-8" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900">
          {t('appUpdate.title')}
        </h1>

        <p className="mt-3 text-sm leading-6 text-gray-600">
          {message || t('appUpdate.message')}
        </p>

        {currentVersionCode != null && (
          <p className="mt-4 text-xs text-gray-500">
            {t('appUpdate.currentVersion', { version: currentVersionCode })}
          </p>
        )}

        {minimumVersionCode != null && (
          <p className="mt-1 text-xs text-gray-500">
            {t('appUpdate.requiredVersion', { version: minimumVersionCode })}
          </p>
        )}

        <div className="mt-6">
          <Button
            type="button"
            onClick={() => openPlayStore(playStoreUrl)}
            className="w-full justify-center gap-2"
          >
            <Download className="h-4 w-4" />
            {t('appUpdate.updateButton')}
          </Button>
        </div>

        <p className="mt-4 text-xs text-gray-400">
          {t('appUpdate.playStoreHint')}
        </p>
      </div>
    </div>
  );
};

export default UpdateRequired;
